const appResources = {
    unauthorizedPathErrorMessage: 'You are not authorized to access the page, please sign in with proper user credentials.'
};
export default appResources;